import { render } from "./SidenavCard.vue?vue&type=template&id=799be2b2&scoped=true"
import script from "./SidenavCard.vue?vue&type=script&lang=js"
export * from "./SidenavCard.vue?vue&type=script&lang=js"

import "./SidenavCard.vue?vue&type=style&index=0&id=799be2b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799be2b2"]])

export default __exports__